import { MARQUEE_ITEMS } from "../data/content";

export const Marquee = () => (
    <div
        data-testid="pillars-marquee"
        className="overflow-hidden border-y border-gold-dark/40 bg-gradient-to-r from-gold-dark via-gold to-gold-dark py-4"
        aria-label="Pilares da CAJUSP"
    >
        <div className="animate-marquee flex w-max">
            {[0, 1].map((copy) => (
                <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
                    {MARQUEE_ITEMS.map((item) => (
                        <span key={`${copy}-${item}`} className="flex items-center">
                            <span className="whitespace-nowrap px-8 font-serif text-xl italic text-graphite-deep sm:text-2xl">
                                {item}
                            </span>
                            <span className="text-sm text-graphite-deep/70">✦</span>
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);
